import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  toggle = (e) => {
    e.preventDefault()
    const eyeIcon = this.element.querySelector("#eye")
    const eyeSlashIcon = this.element.querySelector("#eye-slash")
    const field = this.element.querySelector("input")

    if (!eyeIcon || !eyeSlashIcon || !field) {
      console.error("Required elements not found")
      return
    }

    eyeIcon.parentElement.classList.toggle("hidden")
    eyeSlashIcon.parentElement.classList.toggle("hidden")
    field.type = field.type === "password" ? "text" : "password"
  }
}
